class GeneralInfo {
  constructor(
    public id?: string,
    public averageQuiz?: number,
    public totalUsers?: number,
    public totalUsersActive?: number,
    public totalUsersAlertedAttention?: number,
    public totalUsersFinished?: number,
    public totalUsersInactive?: number,
    public totalUsersWithAttentionDisabled?: number,
    public totalUsersWithAttentionEnabled?: number
  ) { }
}

class Quiz {
  constructor(
    public id?: string,
    public averagePercentage?: number,
    public averageTimeSpent?: number,
    public firstAttempt?: number,
    public learningObjectiveId?: string,
    public learningObjectiveName?: string,
    public secondAttempt?: number,
    public thirdOrMoreAttempt?: number,
    public userAttempts?: number
  ) { }
}

enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DONE = "DONE",
  IN_PROGRESS = "IN_PROGRESS",
}

class Students {
  constructor(
    public userId?: string,
    public averageQuiz?: number,
    public failedQuizzes?: number,
    public userName?: number,
    public userStatus?: Status
  ) { }
}

class GeneralInfoIndividualStudent {
  constructor(
    public userId?: string,
    public photoProfile?: string,
    public averageQuiz?: number,
    public totalsAlertedAttention?: number,
    public userEmail?: string,
    public userName?: string,
    public studentStatus?: any,
    public courseStudentStatus?: any,
    public lastAccess?: string
  ) { }
}

class QuizIndividualStudent {
  constructor(
    public learningObjectiveId?: string,
    public learningObjectiveName?: string,
    public chapterName?: string,
    public quizStudentPercentage?: number,
    public quizPercentage?: number,
    public quizStudentStatus?: boolean
  ) { }
}

class GeneralInfoIndividualObjective {
  constructor(
    public learningObjectiveId?: string,
    public totalQuizAverage?: number
  ) { }
}

class DraftFeedbackObjective {
  constructor(
    public feedbackText?: string,
    public completeFeedbackText?: string,
    public userEmail?: string,
    public completeUserEmail?: string,
    public userName?: string,
    public completeUserName?: string,
  ) { }
}
class QuestionsObjectiveStats {
  constructor(
    public questionId?: string,
    public correctItemId?: string,
    public items?: ItemsObjectiveStats[],
    public prompt?: string,
    public openQuestion?: boolean
  ) { }
}
class QuestionsChatObjectiveStats {
  constructor(
    public correctCount?: number,
    public correctPercentage?: number,
    public incorrectCount?: number,
    public incorrectPercentage?: number,
    public notAnsweredCount?: number,
    public notAnsweredPercentage?: number,
    public prompt?: string
  ) { }
}
class ItemsObjectiveStats {
  constructor(
    public answerText?: string,
    public itemId?: string,
    public choseTimes?: number,
    public quizPercentage?: number,
    public percentage?: number
  ) { }
}
class ObjectsObjectiveStats {
  constructor(
    public id?: string,
    public name?: string,
    public lessonPlan?: string[],
    public liked?: number,
    public disliked?: number
  ) { }
}
class FeedbacksObjectiveStats {
  constructor(
    public count?: number,
    public five?: number,
    public four?: number,
    public netPromoterScore?: number,
    public one?: number,
    public prompt?: string,
    public three?: number,
    public two?: number
  ) { }
}

export {
  GeneralInfo,
  Students,
  Status,
  Quiz,
  GeneralInfoIndividualStudent,
  QuizIndividualStudent,
  GeneralInfoIndividualObjective,
  DraftFeedbackObjective,
  QuestionsObjectiveStats,
  ItemsObjectiveStats,
  QuestionsChatObjectiveStats,
  ObjectsObjectiveStats,
  FeedbacksObjectiveStats
};
